
import { Vue, Component, Prop } from "vue-property-decorator";
import { Project, User, Project_Activity } from "@/generated/graphql";
import ContractorsMultiselect from "@/components/autocompleteMultiselects/ContractorsMultiselectNew.vue";
import ManagementActivityCard from "@/components/projects/activities/ManagementActivityCardNew.vue";
import TableHeaders from "@/views/manage/projectDetails/ActivityHeaders.vue";
import CardPagination from "@/components/card/PaginationNew.vue";
import EmptyListPlaceholder from "@/components/common/EmptyListPlaceholderNew.vue";
import ActivityCustomRequest from "@/components/projects/activities/ActivityCustomRequest.vue";
import LoadingOverlay from "@/components/common/LoadingOverlay.vue";
import FormGroup from "@/components/form/FormGroupNew.vue";
import GET_ACTIVITIES from "@/apollo/projectActivities/GetActivities.gql";
import InfoCircleFilled from "@/components/icons/InfoCircleFilled.vue";
import moment from "moment";
@Component({
  components: {
    ContractorsMultiselect,
    ManagementActivityCard,
    TableHeaders,
    LoadingOverlay,
    CardPagination,
    EmptyListPlaceholder,
    ActivityCustomRequest,
    FormGroup,
    InfoCircleFilled
  },
  apollo:{
    activitiesCompleted: {
      query: GET_ACTIVITIES,
      variables() {
        return this.getActivitiesArgsCompleted;
      },
      update(data) {
        return data.project_activity;
      },
    },
  }
})
export default class CompletedVisits extends Vue {
  @Prop({ type: Object, required: true }) readonly currentUser!: User;
  @Prop({ type: String, required: true }) readonly companyId!: string;
  @Prop({ type: Object, required: true }) readonly project!: Project;

  contractorsIdsCompleted: string[] = [];
  activitiesCompleted: Project_Activity[] = [];
  paginationConfig = {
    page: 1,
    total: 0,
    limit: 8,
    loadedCount: 0,
  };

get getActivitiesArgsCompleted() {
  
    const filterConditions = [];
    if (this.contractorsIdsCompleted.length > 0) {
      filterConditions.push({
        contractor: {
          id: {
            _in: this.contractorsIdsCompleted,
          },
        },
      });
    }
    // Use current UTC time
    const expiredTime = moment.utc().subtract(5, "minutes").toISOString();
    return {
      where: {
        _and: [
          ...filterConditions,
          { project_id: { _eq: this.$route.params.id } },
          { deleted: { _eq: false } },
          {
            _or: [
              { completed: { _eq: true } },
              {
                _and: [
                  { checkin_status: { _is_null: true } },
                  { end_time: { _lte: expiredTime } }
                ]
              }
            ]
          }
        ],
      },
    };
  }

  get isLoading(): boolean {
    return this.$apollo.queries.activitiesCompleted.loading;
  }

  // Check if activities are loaded
  get isActivitiesLoaded(): boolean {
    return this.isLoading && !!this.activitiesCompleted;
  }
  get isEmpty() {
    return !this.activitiesCompleted || this.activitiesCompleted.length === 0;
  }

  matchesSearch(activity, searchInput) {
    const assigneeId = activity.contractor?.user.id;
    return !searchInput.length || searchInput.includes(assigneeId);
  }

  updateContractorsFilter(selectedContractors) {
    this.contractorsIdsCompleted = selectedContractors;
  }

  handlePaginationEvent(newConfig) {
    this.paginationConfig = { ...newConfig };
  }

  onActivityListItemsChanged() {
    this.$emit("activityListChanged");
  }

  get isManager() {
    return this.currentUser.role === "Manager";
  }
}
